module.exports = __webpack_public_path__ + "static/reset-icon.ee51b099.svg";